<template>
  <div class="container">
    <PublicHeader :totalName="$t('public').selectLang" />
    <div class="item" v-for="(item, index) in actions" :key="`lang${index}`" @click="onSelect(item.lang)">
      <div class="left">
        <img :src="require(`@/assets/img/lang/${item.lang}.jpg`)" />
        <div class="txt">{{ item.text }}</div>
      </div>
      <van-checkbox v-if="nowLang == item.lang" icon-size="20" v-model="checked" checked-color="var(--primary_color)"></van-checkbox>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      nowLang: localStorage.getItem('language'),
      checked: true,
      actions: [
        { text: 'English', lang: 'en' },//英语
        { text: '繁體中文', lang: 'zh' },//繁体中文
        { text: '日本語', lang: 'jp' },//日语
        { text: '한국인', lang: 'hy' },//韩语
        { text: 'ภาษาไทย', lang: 'ty' },//泰语
        { text: 'Indonesia', lang: 'yn' },//印尼语
        { text: 'Việt nam', lang: 'yuenan' },//越南文
        { text: 'Français', lang: 'fy' },//法语
        { text: 'Español', lang: 'xby' },//西班牙语
        { text: 'Türkçe', lang: 'tr' },//土耳其语
        // { text: 'Русский язык', lang: 'ey' },//俄语
        // { text: 'Português', lang: 'pty' },//葡萄牙语
        // { text: 'Deutsch', lang: 'dy' },//德语
        // { text: 'កម្ពុជា', lang: 'gmw' },//高棉文
      ]
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {

  },
  methods: {
    //选择语言
    async onSelect(lang) {
      this.nowLang = lang
      this.$i18n.locale = lang
      this.$store.commit('SET_LANG', lang)
      localStorage.setItem('language', lang)
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 50px 15px 20px 15px;
  background: var(--background_color);

  .item {
    margin-top: 15px;
    background: var(--info_color);
    border-radius: 10px;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      display: flex;
      align-items: center;

      img {
        width: 50px;
        height: 33px;
      }

      .txt {
        margin-left: 15px;
        font-weight: bold;
        font-size: 16px;
        color: var(--text_color);
      }
    }
  }
}
::v-deep .van-checkbox__icon--checked .van-icon {
  color: #fff;
}
</style>
